import { backgroundCss, mobileBackgroundCss } from 'common/utils/styleUtilsNew'
import { css, styled } from 'styled-components'

export interface WebsitePageBodyWrapperProps {
  background: string | undefined
  mobileBackground: string | undefined
}

export const WebsitePageBodyWrapper = styled.div<WebsitePageBodyWrapperProps>`
  ${backgroundCss}
  height: 100%;
  ${p => p.theme.phone} {
    ${mobileBackgroundCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileBackgroundCss}
    `}

`
